import * as React from 'react'
import { Input, InputGroup, InputGroupAddon, InputGroupButton, FormGroup, Col, Label } from 'reactstrap'

type InputFieldProps = {
  type?: any
  name: string
  value: string | string[] | undefined | number
  label?: string
  placeholder?: string
  iconClass?: string
  isRequired?: boolean
  options?: any[]
  multiple?: boolean
  maxLength?: number
  disabled?: boolean
  size?: 'lg' | 'sm'
  className?: string
  labelClassName?: string
  helpText?: string | React.ReactNode
  error?: string
  autoFocus?: boolean
  buttonAddOn?: React.ReactNode
  onChange: React.ChangeEventHandler<HTMLInputElement>
  onFocus?: React.FocusEventHandler<HTMLInputElement>
  onBlur?: React.FocusEventHandler<HTMLInputElement>
}

export const renderLabel = (label: string | undefined, forField: string, isRequired: boolean) => {
  const labelElement = (
    <Label for={name} className={isRequired ? 'qmt-required-field text-secondary' : 'text-secondary'}>
      {label}
    </Label>
  )

  return label ? labelElement : <div/>
}

const renderInputField = (data: InputFieldProps) => {
  let { type = 'text', name, value, placeholder, options, multiple, isRequired, iconClass, onChange, maxLength, error,
    buttonAddOn, helpText, disabled, autoFocus, size, onFocus, onBlur } = data
  const inputClassName = error ? 'is-invalid' : ''
  const iconClassName = error ? 'border-right-0 border-danger text-danger' : ''

  const InputAddon = (
    <InputGroupAddon className={iconClassName}>
      <i className={iconClass}/>
    </InputGroupAddon>
  )

  const ButtonAddOn = <InputGroupButton>{buttonAddOn}</InputGroupButton>

  return (
    <div>
      <InputGroup>
        {iconClass && InputAddon}
        <Input
          type={type}
          name={name}
          value={value || ''}
          bsSize={size}
          placeholder={placeholder}
          multiple={multiple}
          className={inputClassName}
          maxLength={maxLength || 100}
          required={isRequired}
          disabled={disabled}
          autoFocus={autoFocus}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
        >
        {options && options.map((item, index) => (
          <option
            key={index}
            value={item.value !== undefined ? item.value : item}
          >
            {item.text !== undefined ? item.text : item}
          </option>)
        )}
        </Input>
        {buttonAddOn && ButtonAddOn}
      </InputGroup>
      <div className="invalid-feedback" style={{ display: 'block' }}>{error}</div>
      <span style={{ fontSize: '11px' }} className="text-secondary">{helpText}</span>
    </div>
  )
}

export const InputField: React.SFC<InputFieldProps> = (props) => {
  let { label, labelClassName, name, isRequired = false, className = 'mb-2' } = props

  return (
    <FormGroup className={className} row={true}>
      <Col md="3" sm="12" xs="12" className={labelClassName}>
        {renderLabel(label, name, isRequired)}
      </Col>
      <Col md={label ? 9 : 12} sm="12" xs="12">
        {renderInputField(props)}
      </Col>
    </FormGroup>
  )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/components/InputField.tsx